import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { schema, uiSchema, translateSchema } from './config';
import BuilderForm from '../FormCarbon';
import NotFound from '../NotFound';
import DataTable from '../DataTable';
import { postTempConfigFile, setTempConfigFile } from '../../../actions';
import funcTranslateHelper from '../../../i18next/funcTranslateHelper';
import { editRoleProcess } from '../OnEdit/onEdit';
import { Modal } from 'carbon-components-react';
import { checkStagesAssetsTransitionsAndUsers } from './onDelete';

const Roles = props => {
  const { configFile, tempConfigFile, saveTempConfigFile, users } = props;

  const [open, setOpen] = useState(false);
  const [notification, setNotification] = useState(null);
  const [formData, setFormData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [affectedDependencies, setAffectedDependencies] = useState({});

  const config = tempConfigFile || configFile;
  const roles = config.roles || [];
  const rows = roles.map(e => parseRoles(e));

  const disableBuilder = config.disableBuilder;

  const headers = [
    { header: 'Roles', key: 'name' },
    { header: 'Crear', key: 'create' },
    { header: 'Editar', key: 'update' },
    { header: 'Leer', key: 'read' }
  ];

  useEffect(() => {
    translateSchema(schema);
  }, []);

  function parseRoles (role) {
    return {
      id: role.id,
      name: role.name,
      ...role.permissions
    };
  }

  const toggleForm = () => {
    setOpen(!open);
    if (open) setFormData({});
  };

  const onAdd = ({ formData }) => {
    formData.id = new Date().getTime().toString();
    const configFile = {
      ...config,
      roles: [...roles, formData]
    };
    saveConfig(configFile);
  };

  const onDelete = async id => {
    const aux = await checkStagesAssetsTransitionsAndUsers(config, id, users);
    setAffectedDependencies(aux);
    if (
      (aux.stagesAffected && aux.stagesAffected.length) ||
      (aux.subStagesAffected && aux.subStagesAffected.length) ||
      (aux.assetsAffected && aux.assetsAffected.length) ||
      (aux.assetsAttrAffected && aux.assetsAttrAffected.length) ||
      (aux.transitionsAffected && aux.transitionsAffected.length) ||
      (aux.usersAffected && aux.usersAffected.length)
    ) {
      setShowModal(true);
    } else {
      const configFile = {
        ...config,
        permissions: config.permissions.filter(
          perm =>
            perm.role !== config.roles.filter(role => role.id === id)[0].name
        ),
        roles: config.roles.filter(role => role.id !== id)
      };
      saveConfig(configFile);
    }
  };

  const openEdit = id => {
    const role = config.roles.filter(role => role.id === id)[0];
    setFormData(role);
    toggleForm();
  };

  const onEdit = async ({ formData }) => {
    const lastRole = config.roles.find(item => item.id === formData.id);
    const newConfigFile = await editRoleProcess(config, lastRole, formData);
    saveConfig(newConfigFile);
    toggleForm();
  };

  const saveConfig = async config => {
    const res = await postTempConfigFile(config);
    if (res.message === 'OK') {
      saveTempConfigFile(config);
      setNotification({
        type: 'success',
        message: funcTranslateHelper('Builder.Message.realizado')
      });
    } else {
      setNotification({
        type: 'error',
        message: funcTranslateHelper('Builder.Message.error')
      });
    }

    setTimeout(() => setNotification(null), 2000);
    if (open) toggleForm();
  };

  if (open) {
    return (
      <BuilderForm
        onAdd={onAdd}
        onEdit={onEdit}
        onClose={toggleForm}
        open={open}
        title={funcTranslateHelper('Builder.Roles.form.titulo')}
        subtitle={funcTranslateHelper('Builder.Roles.form.subtitulo')}
        formData={formData}
        schema={schema}
        uiSchema={uiSchema}
        primaryButtonText={funcTranslateHelper('Guardar')}
        secondaryButtonText={funcTranslateHelper('Cancelar')}
      />
    );
  }

  if (showModal) {
    return (
      <Modal
        className='some-class'
        hasScrollingContent={false}
        iconDescription={funcTranslateHelper(
          'Builder.Roles.modal.iconDescription'
        )}
        modalAriaLabel='A label to be read by screen readers on the modal root node'
        modalHeading={funcTranslateHelper('Builder.Roles.modal.title')}
        onRequestClose={() => {
          setAffectedDependencies({});
          setShowModal(false);
        }}
        open
        passiveModal
        primaryButtonDisabled={false}
        selectorPrimaryFocus='[data-modal-primary-focus]'
        size={undefined}
      >
        <div className='bx--modal-content__text'>
          {funcTranslateHelper('Builder.Roles.modal.message')}
          <br />
          {affectedDependencies.stagesAffected && affectedDependencies.stagesAffected.length > 0 && (
            <>
              <br />
              <strong>
                {funcTranslateHelper('Builder.Roles.modal.stageTitle')}
              </strong>
              <br />
              <ul>
                {affectedDependencies.stagesAffected.map((stage, key) => {
                  let isFirst = true;
                  return (
                    <li key={key}>
                        &emsp; - {stage.name}:{' '}
                      {affectedDependencies.subStagesAffected.map(
                        (subStage, keySubStage) => {
                          let message = '';
                          if (subStage.stage.id === stage.id) {
                            if (isFirst) {
                              message = subStage.subStage.name;
                              isFirst = false;
                            } else {
                              message = ', ' + subStage.subStage.name;
                            }
                          }
                          return message;
                        }
                      )}
                    </li>
                  );
                })}
              </ul>
            </>
          )}
          {affectedDependencies.assetsAffected && affectedDependencies.assetsAffected.length > 0 && (
            <>
              <br />
              <strong>
                {funcTranslateHelper('Builder.Roles.modal.assetTitle')}
              </strong>
              <br />
              <ul>
                {affectedDependencies.assetsAffected.map((asset, key) => {
                  let isFirst = true;
                  return (
                    <li key={key}>
                      &emsp; - {asset.name}:{' '}
                      {affectedDependencies.assetsAttrAffected.map(
                        (attr) => {
                          let message = '';
                          if (attr.asset.id === asset.id) {
                            if (isFirst) {
                              message = attr.attr.title;
                              isFirst = false;
                            } else {
                              message = ', ' + attr.attr.title;
                            }
                          }
                          return message;
                        }
                      )}
                    </li>
                  );
                })}
              </ul>
            </>
          )}

          {affectedDependencies.transitionsAffected && affectedDependencies.transitionsAffected.length > 0 && (
            <>
              <br />
              <strong>
                {funcTranslateHelper('Builder.Roles.modal.transitionTitle')}
              </strong>
              <br />
              <ul>
                {affectedDependencies.transitionsAffected.map((item, key) => (
                  <li key={key}>&emsp; - {item.nombre}</li>
                ))}
              </ul>
            </>
          )}
          {affectedDependencies.usersAffected && affectedDependencies.usersAffected.length > 0 && (
            <>
              <br />
              <strong>
                {funcTranslateHelper('Builder.Roles.modal.userTitle')}
              </strong>
              <br />
              <ul>
                {affectedDependencies.usersAffected.map((item, key) => (
                  <li key={key}>&emsp; - {item.Username}</li>
                ))}
              </ul>
            </>
          )}
          <br />
          {funcTranslateHelper(
            'Builder.Roles.modal.callToActionMessage'
          )}
          <br />
        </div>
      </Modal>
    );
  }

  if (roles.length === 0) {
    return (
      <NotFound
        title='Assets'
        subtitle='Subtitle'
        handleOpen={toggleForm}
        notification={notification}
        message={"Here's where you would add new roles"}
      />
    );
  }

  return (
    <div className='data-table-container'>
      <DataTable
        title={funcTranslateHelper('Builder.Roles.titulo')}
        subtitle={funcTranslateHelper('Builder.Roles.subtitulo')}
        headers={headers}
        rows={rows}
        handleOpen={toggleForm}
        onDelete={onDelete}
        onEdit={openEdit}
        rawData={roles}
        notification={notification}
        allowEdit={!disableBuilder}
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    configFile: state.configFile,
    tempConfigFile: state.tempConfigFile,
    users: state.users
  };
};

const mapDispatchToProps = dispatch => {
  return {
    saveTempConfigFile: data => dispatch(setTempConfigFile(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Roles);
